
import { Page, View, Document } from '@react-pdf/renderer';

import { Header } from "../../Header";
import { Footer } from "../../Footer";
import { Watermark } from "../../Watermark";

import { Medicines } from './Medicines';

import { container, content } from './styles';

export function PrescriptionDocument() {
  return (
    <Document>
      <Page size="A4" style={container} wrap>
        <Header.Root>
          <Header.Store />
          <Header.Pet />
        </Header.Root>
        <View style={content}>
          <Medicines />
        </View>
        <Footer.Root>
          <Footer.Ass />
          <Footer.Date />
          <Footer.Page />
        </Footer.Root>
        <Watermark />
      </Page>
    </Document>
  )
}
